if(typeof jQuery === 'undefined') { var e = new Error("Cannot find module 'jQuery'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = jQuery;